import * as React from 'react'
import {Util, Time} from 'yougile-util'
import {Lang} from 'yougile-lang'
import {paymentDaysLeft} from 'yougile-model'
import {BillingProps} from './billing-base'
import {setDisplayName} from '../../../common/utils-ui'

export const BillingStatus = (props: BillingProps) => {
  const {paymentStatus, onChange, license} = props
  const bem = Util.bemFrom('billing')
  const daysLeft = paymentDaysLeft(paymentStatus)
  const isFree = daysLeft <= 0
  const expiresSoon = daysLeft < 30
  const addUsersClick = () =>
    onChange({
      ...license,
      type: isFree ? 'buy' : 'add-users',
      users: 5
    })
  const prolongClick = () =>
    onChange({
      ...license,
      type: license.type === 'prolong' ? 'buy' : 'prolong',
      months: license.months
    })
  const expiresDays = Lang.msg.daysLeft(daysLeft)
  const expiresDate =
    paymentStatus &&
    Time.formatDate(paymentStatus.expiration, {alwaysWithYear: true})
  return (
    <div className={bem('section')}>
      <div className={bem('descr')}>{Lang.msg.billingCurrentTariffPlan}</div>
      <div className={bem('large')}>{Lang.msg.bill.tariffCloud}</div>

      <div className={bem('users-line')}>
        <div className={bem('users-count')}>{Lang.msg.bill.freeUsers}</div>
        <div className={bem('users-expl')}>{Lang.msg.bill.forFree}</div>
      </div>
      {!isFree && (
        <>
          <div className={bem('users-line')}>
            <div className={bem('users-count')}>
              {Lang.msg.userCount(paymentStatus.users)}
            </div>
            <div className={bem('users-expl')}>
              {Lang.msg.bill.byLicense}
              <div className={bem('expires', {soon: expiresSoon})}>
                {expiresDate} ({expiresDays})
              </div>
              <div className={bem('prolong')} onClick={prolongClick}>
                {Lang.msg.billingProlong}
              </div>
            </div>
          </div>
          <div className={bem('users-line')}>
            <div className={bem('users-count')}>
              {Lang.msg.bill.totalUser}: <b>{paymentStatus.users + 10}</b>
            </div>
          </div>
        </>
      )}
      <div className={bem('add-users')} onClick={addUsersClick}>
        {Lang.msg.bill.addUsers}
      </div>
    </div>
  )
}
setDisplayName(BillingStatus, 'BillingStatus')
